const messages = {
    cs: {

        "dashboard": "Přehled",
        "accounting": "Vyúčtování",

        "date": "Datum",
        "from-time": "Čas od",
        "to-time": "Čas do",
        "pause": "Pauza",
        "project": "Projekt",
        "note": "Poznámka",
        "add": "Přidat",

        "issuer": "Vydavatel",
        "recipient": "Příjemce",
        "invoice-number": "Číslo faktury",
        "issue-date": "Datum vystavení",
        "vat-payment-date": "Datum d. usk.",
        "payment-date": "Splatnost",

        "your_id": "Přihlašovací jméno",
        "your_password": "Heslo",
        "login": "Příhlásit"

    }
}
export default messages

